<template>
  <AppWithLoading :fetch="getThisDomain">
    <div class="domain row align-stretch">
      <div class="col-12 col-lg-6">
        <div>
          <div class="domain__title">
            {{ $t('connectDomain') }}
          </div>
          <VCol
            v-if="domainYourSaved"
            class="pa-0 mt-6 mb-6"
            cols="12"
            md="6"
          >
            <div class="domain__domain">
              <label for="yourDomain">https://</label>
              <input
                :disabled="!!enterOurDomain"
                @change="setDomainType('domain')"
                id="yourDomain"
                v-model="enterYourDomain"
                type="text"
              >
            </div>

            <div class="domain__btns">
              <VBtn
                @click="saveYourDomain"
                :disabled="!!enterOurDomain"
                class="domain__btn"
                color="#1FC57F"
                link
              >
                {{ $t('saveDomain') }}
              </VBtn>
              <VBtn
                v-if="!!enterYourDomain"
                @click="deleteThisDomain"
                class="domain__btn"
                color="#1FC57F"
                link
              >
                {{ $t('deleteDomain') }}
              </VBtn>
            </div>
            <VCol v-if="sendDomainType === 'domain'" cols="12" class="red--text text-left mb-0 pl-0 pb-0">
              {{ yourError }}
            </VCol>
          </VCol>

          <VCol
            v-if="domainOurSaved"
            class="pa-0 mt-6 mb-6"
            cols="12"
            md="6"
          >
            <div class="mb-3">
              {{ $t('ifNotDomain') + ` *${myHost}` }}
            </div>

            <div class="domain__domain">
              <label for="subdomain">https://</label>
              <input
                :disabled="!!enterYourDomain"
                @change="setDomainType('subDomain')"
                id="subdomain"
                v-model="enterOurDomain"
                type="text"
              >
              <label for="subdomain">{{ myHost }}</label>
            </div>
            <div class="domain__btns">
              <VBtn
                @click="saveOurDomain"
                :disabled="!!enterYourDomain"
                class="domain__btn"
                color="#1FC57F"
                link
              >
                {{ $t('saveDomain') }}
              </VBtn>
              <VBtn
                v-if="!!enterOurDomain"
                @click="deleteThisDomain"
                class="domain__btn"
                color="#1FC57F"
                link
              >
                {{ $t('deleteDomain') }}
              </VBtn>
            </div>
            <VCol v-if="sendDomainType === 'subDomain'" cols="12" class="red--text text-left mb-0 pl-0 pb-0">
              {{ ourError }}
            </VCol>
          </VCol>
          <RouterLink :to="{ name: 'instructions-domain' }" class="mt-3">
            {{ $t('instructionsDomain') }}
          </RouterLink>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <DomainWizard
          @resetResults="deleteThisDomain"
          @checkDomain="saveOurDomain"
          ref="othercomponent"
        />
      </div>
    </div>
  </AppWithLoading>
</template>

<script>
import { ref } from '@vue/composition-api';
import useDomain from '../../compositions/useDomain';
import AppWithLoading from '../AppWithLoading.vue';
import DomainWizard from './DomainWizard.vue';

export default {
  name: 'Domain',
  components: { AppWithLoading, DomainWizard },
  setup() {
    const { setDomain, getDomain, deleteDomain } = useDomain();

    const enterYourDomain = ref('');
    const enterOurDomain = ref('');

    const sendDomainType = ref(null);

    const domainYourSaved = ref(true);
    const domainOurSaved = ref(true);

    const yourError = ref(null);
    const ourError = ref(null);

    const myHost = window.location.host.replace('cabinet', '');

    function setDomainType(type) {
      sendDomainType.value = type;
    }

    async function saveYourDomain() {
      try {
        setDomainType('domain');
        await setDomain(enterYourDomain.value);
        enterOurDomain.value = '';
        this.$toast.success(this.$t('savedDomain'));
        this.$router.push({ name: 'instructions-domain' });
        domainOurSaved.value = false;
      } catch (e) {
        if (e.name !== 'ApiError') {
          throw e;
        }
        this.yourError = e.message;
      }
    }

    async function saveOurDomain() {
      try {
        setDomainType('subDomain');
        await setDomain(enterOurDomain.value ? `${enterOurDomain.value}${myHost}` : '');
        enterYourDomain.value = '';
        domainYourSaved.value = false;
        this.$toast.success(this.$t('savedDomain'));
        this.$refs.othercomponent.checkDomain();
        this.$emit('checkDomain');
        this.ourError = null;
        this.yourError = null;
      } catch (e) {
        if (e.name !== 'ApiError') {
          throw e;
        }
        this.ourError = e.message;
      }
    }

    async function getThisDomain() {
      const domain = await getDomain();
      if (!!domain && window.location.host) {
        if (domain.includes(myHost)) {
          enterOurDomain.value = domain.replace(myHost, '');
          domainYourSaved.value = false;
        } else {
          enterYourDomain.value = domain;
          domainOurSaved.value = false;
        }
      }
    }

    async function deleteThisDomain() {
      await deleteDomain();
      enterOurDomain.value = '';
      enterYourDomain.value = '';
      domainYourSaved.value = true;
      domainOurSaved.value = true;
      this.ourError = null;
      this.yourError = null;
      this.$refs.othercomponent.hideResults();
      this.$emit('resetResults');
    }

    return {
      enterOurDomain,
      enterYourDomain,
      saveYourDomain,
      saveOurDomain,
      deleteThisDomain,
      getThisDomain,
      yourError,
      ourError,
      myHost,
      domainOurSaved,
      domainYourSaved,
      sendDomainType,
      setDomainType,
    };
  },
};
</script>

<style scoped lang="scss">
.domain {
  &__btn {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
  }
  &__title {
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    color: #212121;
  }
  &__btns {
    display: flex;
    gap: 10px;
  }
  &__domain {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    width: 100%;
    input {
      border: none;
      outline: none;
      border-bottom: 1px solid black;
      width: 100%;
    }
    label {
      color: gray;
      border-bottom: 1px solid black;
    }
  }
}
</style>

<i18n lang="yml" locale="en">
connectDomain: Connect to your domain
saveDomain: Save
savedDomain: Domain saved
enterYourDomain: Enter your domain
enterOurDomain: Enter domain
ifNotDomain: If you don't have your own domain, you can use ours
deleteDomain: Delete domain
instructionsDomain: Domain connection instructions
</i18n>

<i18n lang="yml" locale="ru">
connectDomain: Подключить свой домен
saveDomain: Сохранить
savedDomain: Домен сохранен
enterYourDomain: '*Введите свой домен'
enterOurDomain: '*Введите домен'
ifNotDomain: Если вы не имеете своего домена, можете воспользоваться нашим
deleteDomain: Отвязать домен
instructionsDomain: Инструкция по подключению домена
</i18n>
